import React from 'react';
import {
    Card, CardImg, CardText, CardBody, UncontrolledCollapse,
    Button,
    Container,
    Row,
    Col
} from 'reactstrap';

import ArticulosInicio from '../../../../public/img/Help/ArticulosInicio.png';
import ArticuloEditar from '../../../../public/img/Help/ArticuloEditar.png';
import ArticulosCategoriasAsignar from '../../../../public/img/Help/ArticulosCategoriasAsignar.png';

import CategoriasInicio from '../../../../public/img/Help/CategoriasInicio.png';
import CategoriasCreacion from '../../../../public/img/Help/CategoriasCreacion.png';

import OfertasInicio from '../../../../public/img/Help/OfertasInicio.png';
import OfertasCreacion from '../../../../public/img/Help/OfertasCreacion.png';
import OfertasArticulos from '../../../../public/img/Help/OfertasArticulos.png';

import DestacadosArticulos from '../../../../public/img/Help/DestacadosArticulos.png';
import DestacadosCreacion from '../../../../public/img/Help/DestacadosCreacion.png';
import DestacadosInicio from '../../../../public/img/Help/DestacadosInicio.png';

const Articulos = () => {
    return (
        <Container fluid className="rounded contenedor-scrolleable">
            <header>
                <h2 className="text-center">Artículos</h2>
                <h6>En esta sección encontrara información sobre los artículos y las funcionalidades existentes en relación a ellos como propiedades, artículos destacados y ofertados.</h6>
            </header>
            <div>
                <Button color="primary" id="ArticulosInicio" style={{ marginBottom: '1rem' }}>
                    ¿Que puedo hacer en la sección de artículos?
                </Button>
                <UncontrolledCollapse toggler="#ArticulosInicio">
                    <Card>
                        <CardImg top width="100%" src={ArticulosInicio} className="img-fluid" alt="Seccion Articulos" title="Seccion Articulos" />
                        <CardBody>
                            <CardText>
                                Se listan los artículos actualmente cargados, se disponen de filtros para visualizar un subconjunto de artículos que son de interés.<br />
                                Sobre dicha colección de elementos es posible modificar su visibilidad (Visible o Invisible en Web) y/o asignar una categoría.<br/>
                                Manteniendo tecla Ctrl puede realizar una selección múltiple manual sobre varias filas en una tabla.
                            </CardText>
                        </CardBody>
                        <CardImg top src={ArticulosCategoriasAsignar} className="img-modal-content" alt="Articulos - Carga de Categoria" title="Articulos - Carga de Categoria" />
                    </Card>
                </UncontrolledCollapse>
                <br />

                <Button color="primary" id="ArticulosDetalle" style={{ marginBottom: '1rem' }}>
                    ¿Que puedo hacer en la edición de un artículo?
                </Button>
                <UncontrolledCollapse toggler="#ArticulosDetalle">
                    <Card>
                        <CardImg top src={ArticuloEditar} className="img-modal-content" alt="Articulos - Detalle de Articulo" title="Detalle de Articulo" />
                        <CardBody>
                            <CardText>
                                Es posible editar el titulo, su visibilidad, y dos campos para información adicional (Detalle e Información).<br />
                                También es posible cargar las imágenes del artículo (si tuviese) y asignar artículos que están en relación al existente.
                            </CardText>
                        </CardBody>
                    </Card>
                </UncontrolledCollapse>
                <br />

                <Button color="primary" id="Categorias" style={{ marginBottom: '1rem' }}>
                    Categorías: Una forma de clasificar los artículos
                </Button>
                <UncontrolledCollapse toggler="#Categorias">
                    <Card>
                        <CardImg top width="100%" src={CategoriasInicio} className="img-fluid" alt="Seccion Categorias" title="Seccion Categorias" />
                        <CardBody>
                            <CardText>
                                Cuando se cargan los artículos en sistema, dichos artículos no van a pertenecer a ninguna categoría. Es obligatorio asignarles una categoría para poder emplearlos como Artículos Destacados u Ofertados.<br />
                            </CardText>
                        </CardBody>
                        <CardImg top src={CategoriasCreacion} className="img-modal-content" alt="Creacion de Categoria" title="Creacion de Categoria" />
                    </Card>
                </UncontrolledCollapse>
                <br />

                <Button color="primary" id="Ofertas" style={{ marginBottom: '1rem' }}>
                    Ofertas en Web: ¿Como trabaja y que relación hay con las condiciones de pago?
                </Button>
                <UncontrolledCollapse toggler="#Ofertas">
                    <Card>
                        <CardImg top width="100%" src={OfertasInicio} className="img-fluid" alt="Seccion Ofertas" title="Seccion Ofertas" />
                        <CardBody>
                            <CardText>
                                Para crear una oferta se debe definir un titulo que se mostrara en web así como una descripción adicional para saber de que se trata. Luego, se ha de seleccionar los artículos que han de formar parte de la oferta simplemente poniendo el % de descuento que se desea aplicar sobre dicho articulo.<br />
                            </CardText>
                            <Row>
                                <Col>
                                    <CardImg top src={OfertasCreacion} className="img-fluid" alt="Creacion de Ofertas" title="Creacion de Oferta" />
                                </Col>
                                <Col>
                                    <CardImg top src={OfertasArticulos} className="img-fluid" alt="Seleccion de Articulos" title="Seleccion de Articulos" />
                                </Col>
                            </Row>
                            <CardText>
                                En relación a las condiciones de pago, estas contienen un recargo y un descuento asociado. Dichos porcentajes se aplican al momento de computar precios finales. Por ende los descuentos definidos en la oferta se adicionan al porcentaje de descuento de todas las condiciones de pago.
                            </CardText>
                        </CardBody>
                    </Card>
                </UncontrolledCollapse>
                <br />

                <Button color="primary" id="Destacados" style={{ marginBottom: '1rem' }}>
                    Definiendo Artículos Destacados en Web
                </Button>
                <UncontrolledCollapse toggler="#Destacados">
                    <Card>
                        <CardImg top width="100%" src={DestacadosInicio} className="img-fluid" alt="Seccion Destacados" title="Seccion Destacados" />
                        <CardBody>
                            <CardText>
                                En forma similar a la creación de una oferta, se debe establecer una descripción meramente informativa y un titulo en web. Luego elegir aquellos artículos que se consideran destacados.
                            </CardText>
                            <Row>
                                <Col>
                                    <CardImg top src={DestacadosCreacion} className="img-fluid" alt="Creacion de Destacados" title="Creacion de Destacados" />
                                </Col>
                                <Col>
                                    <CardImg top src={DestacadosArticulos} className="img-fluid" alt="Seleccion de Articulos" title="Seleccion de Articulos" />
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </UncontrolledCollapse>
                <br />
            </div>
        </Container>
    )
}

export default Articulos;


// WEBPACK FOOTER //
// ./src/views/Ayuda/Paneles/Articulos.js